import { RelatedUser } from './User'

export const AgreementStatusConfirm = 1
export const AgreementStatusAccept = 2
export const AgreementStatusReject = 3

export type AgreementFlow = {
  step: number
  user: RelatedUser
  status: 1 | 2 | 3
}

export type Agreement = {
  id: string
  name: string
  status: number
  fileName: string
  fileUrl: string
  rejectReason: string | null
  companies: {
    company: {
      id: string
      name: string
    }
    confirmable: boolean
    confirmedAt: string | null
  }[]
  companyFlows: {
    companyId: string
    flows: AgreementFlow[]
  }[]
}
